<template>
  <div>
    <MapMyIndia />
  </div>
</template>

<script>
import MapMyIndia from "../../components/incidents/map.vue";
export default {
  components: {
    MapMyIndia,
  },
};
</script>

<style scoped>
.map-height {
  height: 400px;
}
</style>
